export const categoryCellStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const requestedOverStyles = {
  color: 'error.main',
};
